<template>
    <header v-if="logged_in" class="rd-header">
        <div class="rd-header__inner">
            <router-link to="/" class="rd-brand">
                <img :src="chamber.logo" alt="logo" class="rd-brand__logo" />
                <span class="rd-brand__name">
                    HRVATSKA KOMORA<br><strong>{{ chamber.name }}</strong>
                </span>
            </router-link>

            <button v-if="!$embedded" class="rd-burger" :class="{ open: isMenuOpen }" @click="toggleMenu" aria-label="Izbornik">
                <span></span><span></span><span></span>
            </button>

            <nav class="rd-nav" :class="{ open: isMenuOpen }">
                <a v-if="!$embedded" :href="'doc/' + app_owner.toLowerCase() + '.pdf'" download class="rd-link">
                    Upute za korištenje
                </a>
                <button v-if="!$embedded" class="rd-logout" @click.prevent="logout">Odjava</button>
            </nav>
        </div>
    </header>
</template>

<script>


import axios from "axios";
import toastr from "toastr"
import { mapGetters, mapActions } from "vuex";
export default {
    name: "NavigationTop",
    data(){
        return {
            logged_in: false,
            app_owner: process.env.VUE_APP_APP_OWNER,
            open_dropdown:true,
            isMenuOpen: false,
        }
    },
    computed: {
        ...mapGetters("auth", ["user"]),
        chamber() {
            const map = {
                HKIE:  { logo: require('../../img/logo/hkie.png'), name: 'INŽENJERA ELEKTROTEHNIKE' },
                HKIG:  { logo: require('../../img/logo/hkig.png'), name: 'INŽENJERA GRAĐEVINARSTVA' },
                HKIS:  { logo: require('../../img/logo/hkig.png'), name: 'INŽENJERA STROJARSTVA' },
                HKOIG: { logo: require('../../img/logo/hkig.png'), name: 'OVLAŠTENIH INŽENJERA GEODEZIJE' },
            }
            return map[this.app_owner] || map.HKIE
        }
    },
    methods:{
        goto( name ){
            this.$router.push(name)
        },

        ...mapActions("auth", ["getUserData"]),

        logout() {
            let vm = this;
            axios.post(process.env.VUE_APP_API_URL + "logout", {
                email: vm.email,
                password: vm.password
            })
            .then(response => {
                if( response.data.success ){
                    vm.$store.commit("auth/setUserData", null) ;
                    localStorage.removeItem("access_token" );
                    vm.logged_in = false;
                    vm.$router.push("/login")
                } else {
                    toastr.error('Došlo je do greške')
                }
            })
            .catch( function ( error ) {
                if(error instanceof Error) {
                    console.log( 'Error: ' + error);
                } else {
                    console.log( 'Unexpected response: ' + error);
                }
            } )
        },

        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        }
    },
    mounted() {
        if (localStorage.getItem("access_token")) {
            this.getUserData();
            if ( this.user )
                this.logged_in = true
        }
    },
    watch:{
        user: function(){
            if ( this.user )
                this.logged_in = true
        }
    }

}


</script>

<style scoped>
.rd-header {
    position: sticky;
    top: 0;
    z-index: 50;
    background: rgba(255, 255, 255, 0.82);
    backdrop-filter: saturate(180%) blur(14px);
    border-bottom: 1px solid var(--rd-border, #e6e8f0);
    box-shadow: 0 2px 16px -10px rgba(16, 24, 40, .25);
}

.rd-header__inner {
    max-width: 1180px;
    margin: 0 auto;
    padding: .85rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.rd-brand {
    display: flex;
    align-items: center;
    gap: .85rem;
    color: var(--rd-text, #1e2330);
}
.rd-brand:hover { color: var(--rd-text, #1e2330); }
.rd-brand__logo { height: 48px; width: auto; }
.rd-brand__name {
    font-size: .72rem;
    line-height: 1.25;
    letter-spacing: .4px;
    color: #6b7280;
    text-transform: uppercase;
}
.rd-brand__name strong { color: var(--rd-text, #1e2330); font-weight: 800; }

.rd-nav {
    display: flex;
    align-items: center;
    gap: .65rem;
}

.rd-link {
    font-weight: 600;
    font-size: .9rem;
    color: #475067;
    padding: .55rem .9rem;
    border-radius: 12px;
    transition: background .15s ease, color .15s ease;
}
.rd-link:hover { background: #f1f2fb; color: var(--rd-primary-600, #4f46e5); }

.rd-logout {
    font-weight: 700;
    font-size: .9rem;
    color: #fff;
    background: linear-gradient(135deg, #6366f1 0%, #7c3aed 100%);
    border: none;
    padding: .6rem 1.25rem;
    border-radius: 12px;
    cursor: pointer;
    box-shadow: 0 8px 20px -8px rgba(99, 102, 241, .7);
    transition: transform .12s ease, filter .2s ease;
}
.rd-logout:hover { transform: translateY(-1px); filter: brightness(1.06); }

/* burger */
.rd-burger {
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 26px;
    height: 20px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
}
.rd-burger span {
    height: 3px;
    width: 100%;
    background: var(--rd-text, #1e2330);
    border-radius: 3px;
    transition: all .3s ease;
}
.rd-burger.open span:nth-child(1) { transform: rotate(45deg) translate(6px, 6px); }
.rd-burger.open span:nth-child(2) { opacity: 0; }
.rd-burger.open span:nth-child(3) { transform: rotate(-45deg) translate(6px, -6px); }

@media (max-width: 860px) {
    .rd-burger { display: flex; }
    .rd-nav {
        position: absolute;
        top: 100%;
        right: 0;
        left: 0;
        flex-direction: column;
        align-items: stretch;
        gap: .4rem;
        background: #fff;
        padding: 1rem 1.5rem 1.25rem;
        border-bottom: 1px solid var(--rd-border, #e6e8f0);
        box-shadow: var(--rd-shadow, 0 12px 28px -8px rgba(16,24,40,.14));
        display: none;
    }
    .rd-nav.open { display: flex; }
    .rd-link { text-align: center; }
    .rd-logout { width: 100%; }
}
</style>
